import { Input } from "components/Input";
import { Body, Header } from "components/Table/style";
import { Table } from "../../style";

export function Phytase(props) {
  return (
    <Table>
      <Header>
        <tr>
          <th style={{ width: "50px" }}>
            <span></span>
          </th>
          <th>
            <span>Qual Produto?</span>
          </th>
        </tr>
      </Header>
      <Body>
        <tr>
          <td>Cria</td>
          <td>
            <Input
              type="selectOnly"
              params="enzymes.phytase.create.product"
              item={props.heavyBroiler}
              setItem={props.setHeavyBroiler}
              placeholder="Selecione o Produto"
              options={props.config
                .filter((item) => item.key === "enzymesPhytaseProduct")
                .map((item) => ({ value: item.description }))}
            />
          </td>
        </tr>
        <tr>
          <td>Recria</td>
          <td>
            <Input
              type="selectOnly"
              params="enzymes.phytase.recreate.product"
              item={props.heavyBroiler}
              setItem={props.setHeavyBroiler}
              placeholder="Selecione o Produto"
              options={props.config
                .filter((item) => item.key === "enzymesPhytaseProduct")
                .map((item) => ({ value: item.description }))}
            />
          </td>
        </tr>
        <tr>
          <td>Produção</td>
          <td>
            <Input
              type="selectOnly"
              params="enzymes.phytase.production.product"
              item={props.heavyBroiler}
              setItem={props.setHeavyBroiler}
              placeholder="Selecione o Produto"
              options={props.config
                .filter((item) => item.key === "enzymesPhytaseProduct")
                .map((item) => ({ value: item.description }))}
            />
          </td>
        </tr>
      </Body>
    </Table>
  );
}
